/**
 * crypton-main surface config
 * Set these in services/crypton-main/.env (or .env.local for local overrides)
 */
export const DEMO_URL  = process.env.REACT_APP_DEMO_URL  || 'http://localhost:3001';
